module.exports = __webpack_public_path__ + "img/33bc8e4821665fe7c136b4c914ebd729e586ed66.39431151.png";